import { hasPermissions, showAppCreationButton } from '../utils';

import { API_DEMO_URL, CONTACT_SALES, SILA_DOCS_URL, CHANGELOG_URL } from '.';

import IconSupport from '../../../../images/icon-support.svg';

export const ctas = [
  {
    name: 'invite',
    title: 'welcome.actions.invite.title',
    description: 'welcome.actions.invite.description',
    button: 'welcome.actions.invite.button',
    to: '/settings/members/new',
    permissions: (user) => hasPermissions(user, 'members', 'Write'),
  },
  {
    name: 'sila-journey',
    title: 'welcome.actions.silaJourney.title',
    description: 'welcome.actions.silaJourney.description',
    button: 'welcome.actions.silaJourney.button',
    href: CONTACT_SALES,
  },
  {
    name: 'get-started',
    title: 'welcome.actions.getStarted.title',
    description: 'welcome.actions.getStarted.description',
    button: 'welcome.actions.getStarted.button',
    to: '/app/new',
    permissions: (user, env) =>
      user.confirmed_at &&
      !user.hasApps &&
      hasPermissions(user, 'apps', 'Write') &&
      showAppCreationButton(env),
  },
  {
    name: 'whatsNew',
    title: 'welcome.actions.whatsNew.title',
    description: 'welcome.actions.whatsNew.description',
    button: 'welcome.actions.whatsNew.button',
    href: CHANGELOG_URL,
  },
  {
    name: 'learn',
    title: 'welcome.actions.learn.title',
    description: 'welcome.actions.learn.description',
    button: 'welcome.actions.learn.button',
    href: SILA_DOCS_URL,
  },
];

export const blocks = [
  {
    name: 'demo',
    classes: 'decal-left pt-0 pt-lg-4 pt-xl-5',
    title: 'welcome.blocks.demo.title',
    button: 'welcome.blocks.demo.button',
    buttonClass: 'mt-5',
    href: API_DEMO_URL,
  },
  {
    name: 'support',
    classes: 'decal-middle',
    icon: IconSupport,
    title: 'welcome.blocks.support.title',
    description: 'welcome.blocks.support.description',
  },
];
